import React, { useEffect, useState } from 'react';
import FolderTree from '../Componentes/Documentacion/FolderTree';
import EditFolderPermission from '../Componentes/Documentacion/EditFolderPermission';
import { useNavigate, useParams } from 'react-router-dom';
import { collection, getDocs, query, where, doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const DocumentacionConfig = () => {
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [selectedFolderName, setSelectedFolderName] = useState('');
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState(null);
  const navigate = useNavigate();
  const { hubId } = useParams();

  const [refreshFolders, setRefreshFolders] = useState(false);

  // 👇 Estado inicial en false
  const [useBlocktrace, setUseBlocktrace] = useState(false);

  const triggerFolderRefresh = () => {
    setRefreshFolders(prev => !prev);
  };

  // 📌 Obtener usuarios del hub
  useEffect(() => {
    const obtenerUsuariosDelHub = async () => {
      try {
        const usuariosRef = collection(db, 'usuarios');
        const q = query(
          usuariosRef,
          where('hubId', 'array-contains-any', [hubId, '__superadmin__'])
        );
        const querySnapshot = await getDocs(q);
        const usuariosList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUsuarios(usuariosList);
      } catch (error) {
        console.error("Error al obtener usuarios del hub:", error);
      }
    };

    if (hubId) {
      obtenerUsuariosDelHub();
    }
  }, [hubId]);

  // 📌 Obtener el valor de useBlocktrace del hub
  useEffect(() => {
    const fetchUseBlocktrace = async () => {
      try {
        const hubDocRef = doc(db, 'private-hubs', hubId);
        const hubSnap = await getDoc(hubDocRef);
        if (hubSnap.exists()) {
          // Si el campo no existe, usamos false
          const data = hubSnap.data();
          setUseBlocktrace(data.useBlocktrace ?? false);
        } else {
          setUseBlocktrace(false);
        }
      } catch (error) {
        console.error("Error al obtener useBlocktrace:", error);
        setUseBlocktrace(false);
      }
    };

    if (hubId) {
      fetchUseBlocktrace();
    }
  }, [hubId]);

  const handleBlocktraceChange = async (e) => {
    const newValue = e.target.checked;
    setUseBlocktrace(newValue);
    try {
      const hubDocRef = doc(db, 'private-hubs', hubId);
      await updateDoc(hubDocRef, { useBlocktrace: newValue });
    } catch (error) {
      console.error("Error al actualizar useBlocktrace:", error);
    }
  };

  return (
    <div className="lobby-container">
      {/* Header */}
      <div className="header-container">
        <header className="header">
          <h1 className="header-title">Configuración del área de documentación</h1>
          <div className="logout-button-container">
            <button onClick={() => navigate(-1)} className="logout-button">
              ← Volver
            </button>
          </div>
        </header>
      </div>

      {/* Contenido principal */}
      <div className="dashboard-grid">
        {/* Columna izquierda */}
        <div className="dashboard-column">
          <div className="data-box">
            <h2 className="data-box-title">Carpetas</h2>

            {/* Selector de usuario */}
            <div className="mb-4">
              <label htmlFor="user-select" className="labelText">
                Selecciona un usuario
              </label>
              <select
                id="user-select"
                className="labelText"
                style={{ padding: '6px 12px', fontSize: '1rem', marginBottom: '10px' }}
                value={selectedUser || ''}
                onChange={(e) => {
                  setSelectedUser(e.target.value || null);
                  setSelectedUserName(
                    usuarios.find(user => user.id === e.target.value)?.email || null
                  );
                }}
              >
                <option value="">-- Ninguno seleccionado --</option>
                {usuarios
                  .filter((user) => !user.hubId.includes('__superadmin__'))
                  .map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.nombre || user.email || user.id}
                    </option>
                  ))}
              </select>
            </div>

            {/* Árbol de carpetas */}
            <FolderTree
              onSelectFolder={(folderName, folderId) => {
                setSelectedFolderName(folderName);
                setSelectedFolderId(folderId);
              }}
              onSelectFolderObject={(folderObj) => setSelectedFolder(folderObj)}
              selectedUserId={selectedUser}
              refresh={refreshFolders}
            />

            {/* Checkbox de Blocktrace */}
            <div style={{ margin: '1rem 0', padding: '0.5rem'}}>
              <label style={{ fontWeight: 'bold' }}>
                <input
                  type="checkbox"
                  checked={useBlocktrace}
                  onChange={handleBlocktraceChange}
                  style={{ marginRight: '8px' }}
                />
                Registro en Blockchain de la actividad del Hub
              </label>
            </div>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="dashboard-column">
          <div className="data-box">
            <h2 className="data-box-title" style={{lineHeight: '1.5'}}>Permisos de {selectedFolderName}</h2>
            {selectedFolder && selectedUser && (
              <EditFolderPermission
                hubId={hubId}
                selectedUserId={selectedUser}
                selectedUserName={selectedUserName}
                folder={selectedFolder}
                onPermissionsUpdated={triggerFolderRefresh}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentacionConfig;
